// sass
import './sass/index.sass'; //sprite-svg

function requireAll(r) {
  r.keys().forEach(r);
}

requireAll(require.context('./media/sprite/', true, /\.svg$/)); // js

import './js/index.js';